import React from 'react';
import { Modal, Button } from 'antd';

interface ConfirmationModalProps {
    title: string;
    okText: string;
    cancelText: string;
    visible: boolean;
    isLoading?: boolean;
    confirmationText: string;
    onClose: () => void;
    onClick: () => void;
}

/**
 * Modal component for confirming dataset deletion.
 * Renders a modal dialog with a confirmation message and handles the deletion of a dataset.
 * */
function ConfirmationModal({
    title,
    okText,
    visible,
    cancelText,
    onClose,
    onClick,
    confirmationText,
    isLoading,
}: ConfirmationModalProps) {
    return (
        <>
            {/* Display confirmation modal when the button is clicked */}
            <Modal
                centered
                okText={okText}
                closable={false}
                visible={visible}
                onCancel={onClose}
                className="f-dialog"
                cancelText={cancelText}
                footer={
                    <>
                        <Button type="default" onClick={onClose}>
                            {cancelText || ''}
                        </Button>
                        <Button className="ant-btn-dangerous" onClick={onClick} danger disabled={isLoading}>
                            {okText || ''}
                        </Button>
                    </>
                }
            >
                <h1 className="f-dialog-title">{title}</h1>
                <p className="f-dialog-text">{confirmationText || ''}</p>
            </Modal>
        </>
    );
}

export default ConfirmationModal;
